<template>
  <div class="content"
       id="content"
       style="position: fixed; bottom: 99999px;">
    <canvas id="myCanvas"
            ref="myCanvas"
            type="2d"
            class="cavanss"
            style="width: 349px; height: 465px;" />
  </div>
</template>

<script>
import { uploadImg } from '@/api/common'
export default {
  name: 'Photofunia',
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      },
    },
    inputText: {
      type: String,
      default: '',
    },
    singal: {
      type: Boolean,
      default: false,
    },
    startInit: {
      type: Boolean,
      default: () => {
        return false
      },
    },
    startGenerating: {
      type: Boolean,
      default: () => {
        return false
      },
    },
  },
  data() {
    return {
      pixelRatio: 1,
      inputVal: '',
      canvas: '',
      progress: 0,
      number: 0,
      index: 0,
      w: 0,
      h: 0,
      pictureList: [],
      fontlist: [
        {
          fontFamily: 'SanJiXingKaiJianTi',
          url: 'https://upload.kaoyanbox.net/8389c76af36c414844d634cd694b9aa4.ttf',
        },
        {
          fontFamily: 'AlimamaShuHeiTi',
          url: 'https://upload.kaoyanbox.net/566ee277d4ec78098cdf414ef726d127.ttf',
        },
        {
          fontFamily: 'YSHaoShenTi',
          url: 'https://upload.kaoyanbox.net/3dae6eb4f41bee2401523f1c02d0b59b.ttf',
        },
        {
          fontFamily: 'YouSheBiaoTiHei',
          url: 'https://upload.kaoyanbox.net/84b7b30fd32f7a23a7a8afb5a5deb819.ttf',
        },
      ],
      canvasNode: null,
      ctx: null,
      canvasW: 0,
      canvasH: 0,
    }
  },
  watch: {
    startInit: {
      handler: function (newVal, oldVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.canvasNode = this.$refs.myCanvas
            this.canvasW = this.canvasNode.clientWidth
            this.canvasH = this.canvasNode.clientHeight
            const dpr = window.devicePixelRatio || 1
            this.canvasNode.width = this.canvasW * dpr
            this.canvasNode.height = this.canvasH * dpr
            this.ctx = this.canvasNode.getContext('2d')
            if (this.ctx) {
              this.ctx.scale(dpr, dpr)
            }
          })
        }
      },
      immediate: true, // 注意这里没有引号，且值与键之间用冒号分隔
    },
    startGenerating: {
      handler: function (newVal, oldVal) {
        if (newVal) {
          this.preloadFonts(this.fontlist).then((res) => {
            setTimeout(() => {
              this.drawCanvas(
                this.canvasNode.width,
                this.canvasNode.height,
                this.list[this.index]
              )
            }, 2000)
          })
        }
      },
      immediate: true, // 注意这里没有引号，且值与键之间用冒号分隔
    },
  },
  mounted() {
    this.preloadFonts(this.fontlist)
  },
  methods: {
    // 绘制背景图片
    drawImg(ctx, url, x = 0, y = 0, width = 349, height = 465, circle = false) {
      return new Promise((reslove, reject) => {
        const image = new Image()
        image.onload = () => {
          ctx.drawImage(image, x, y, width, height)
          if (circle) {
            ctx.restore() // 恢复状态
          }
          reslove(1)
        }
        // 设置图片src
        image.src = url
      })
    },
    // 修复核心：完全移除 setFontSize，统一用 ctx.font 设置字体
    drawTextInArea(
      ctx,
      text,
      x1,
      y1,
      x2,
      y2,
      maxFontSize,
      minFontSize,
      debug = true,
      options = {}
    ) {
      const {
        lineHeight,
        letterSpacing,
        color,
        fontWeight,
        fontFamily,
        padding,
        aline,
      } = options
      const areaX = x1 + padding
      const areaY = y1 + padding
      const areaWidth = Math.max(0, x2 - x1 - padding * 2)
      const areaHeight = Math.max(0, y2 - y1 - padding * 2)
      if (debug) {
        ctx.setLineDash([10, 10])
        ctx.strokeStyle = 'red'
        ctx.lineWidth = 1
        ctx.strokeRect(areaX, areaY, areaWidth, areaHeight)
        ctx.setLineDash([])
      }
      let fontSize = maxFontSize
      let lines = []

      // 测量带字间距的文本宽度
      const measureTextWithSpacing = (text) => {
        const baseWidth = ctx.measureText(text).width
        return baseWidth + Math.max(0, text.length - 1) * letterSpacing
      }

      // 换行处理
      const wrapText = (text, maxWidth) => {
        const lines = []
        let currentLine = ''
        const words = text
          .split(/(\s+)/)
          .filter((word) => word.trim().length > 0)

        for (let i = 0; i < words.length; i++) {
          const word = words[i]
          const testLine = currentLine + (currentLine ? ' ' : '') + word
          const testWidth = measureTextWithSpacing(testLine)

          if (testWidth <= maxWidth) {
            currentLine = testLine
          } else {
            if (currentLine) lines.push(currentLine)
            if (measureTextWithSpacing(word) <= maxWidth) {
              currentLine = word
            } else {
              currentLine = ''
              for (let j = 0; j < word.length; j++) {
                const char = word[j]
                const testCharLine = currentLine + char
                const testCharWidth = measureTextWithSpacing(testCharLine)
                if (testCharWidth <= maxWidth) {
                  currentLine = testCharLine
                } else {
                  lines.push(currentLine)
                  currentLine = char
                }
              }
            }
          }
        }

        if (currentLine) lines.push(currentLine)

        return lines
      }

      // 查找最佳字体大小：只通过 ctx.font 设置，无 setFontSize
      while (fontSize > minFontSize) {
        ctx.font = `${fontWeight} ${fontSize}px ${fontFamily}` // 关键：统一设置字体
        lines = wrapText(text, areaWidth)
        const actualLineHeight = fontSize * lineHeight
        const totalHeight = lines.length * actualLineHeight
        if (totalHeight <= areaHeight) break
        fontSize--
      }

      // 最小字体处理
      if (fontSize === minFontSize) {
        ctx.font = `${fontWeight} ${fontSize}px ${fontFamily}` // 再次确认字体大小
        const actualLineHeight = fontSize * lineHeight
        const maxLines = Math.floor(areaHeight / actualLineHeight)
        if (lines.length > maxLines) {
          lines = lines.slice(0, maxLines)
          let lastLine = lines[lines.length - 1]
          const ellipsis = '...'

          // 调整最后一行加省略号（需重新测量，确保字体正确）
          while (lastLine.length > 0) {
            const testLine = lastLine + ellipsis
            const testWidth = measureTextWithSpacing(testLine)
            if (testWidth <= areaWidth) {
              lines[lines.length - 1] = testLine
              break
            }
            lastLine = lastLine.substring(0, lastLine.length - 1)
          }

          if (lastLine.length === 0 && lines.length > 0) {
            lines[lines.length - 1] = ellipsis
          }
        }
      }
      // 绘制文本：最终设置字体（无 setFontSize）
      const actualLineHeight = fontSize * lineHeight
      const totalTextHeight = lines.length * actualLineHeight
      const startY = areaY + (areaHeight - totalTextHeight) / 2
      ctx.font = `${fontWeight} ${fontSize}px ${fontFamily}` // 最终确认字体样式
      ctx.fillStyle = color
      ctx.textBaseline = 'top' // 文本基线对齐顶部
      // 逐行绘制
      lines.forEach((line, index) => {
        const lineWidth = measureTextWithSpacing(line)
        let startX = areaX
        if (aline === 'center') {
          startX = areaX + (areaWidth - lineWidth) / 2
        }

        if (letterSpacing > 0) {
          let currentX = startX
          for (let i = 0; i < line.length; i++) {
            const char = line[i]
            ctx.fillText(char, currentX, startY + index * actualLineHeight)
            currentX += ctx.measureText(char).width + letterSpacing
          }
        } else {
          ctx.fillText(line, startX, startY + index * actualLineHeight)
        }
      })

      return fontSize
    },
    async drawCanvas(width, height, data) {
      return new Promise((resolve) => {
        this.ctx.clearRect(0, 0, width, height)

        const {
          url,
          x1,
          y1,
          x2,
          y2,
          maxFontSize,
          minFontSize,
          debug,
          options,
        } = data

        //  绘制背景
        this.drawImg(this.ctx, url, 0, 0, width, height, false).then(() => {
          //绘制文本
          this.drawTextInArea(
            this.ctx,
            this.inputText,
            x1,
            y1,
            x2,
            y2,
            maxFontSize,
            minFontSize,
            debug,
            options
          )
          this.saveAndContinue(width, height)
        })
      })
    },
    // 保存 Canvas 为图片并上传（原生改造核心）
    async saveAndContinue(width, height) {
      try {
        const canvas = this.$refs.myCanvas

        // 1. 原生 Canvas 2D 导出 Blob（替代 uni.canvasToTempFilePath）
        const blob = await new Promise((resolve, reject) => {
          canvas.toBlob(
            (blob) => {
              if (blob) resolve(blob)
              else
                reject(
                  new Error(
                    'Canvas 生成 Blob 失败（可能是跨域污染或 Canvas 为空）'
                  )
                )
            },
            'image/png',
            1
          )
        })

        // 2. 原生 fetch 上传图片（替代 uni.uploadFile）
        const uploadRes = await this.uploadImageBlob(blob)

        // 3. 解析上传结果（与原逻辑一致）
        const resData = uploadRes.data
        if (resData) {
          this.pictureList.push(resData)
        }

        // 4. 处理下一个绘制项
        this.index++
        this.$emit('ondraw', {
          finished: this.index == this.pictureList.length,
          progress: (this.index / this.pictureList.length) * 100,
        })
        if (this.index < this.list.length) {
          await this.drawCanvas(width, height, this.list[this.index])
        } else {
          // 所有项处理完成，发射完成事件
          this.$emit('ondrawed', {
            picture: this.pictureList,
          })
          this.index = 0
          this.pictureList = []
          // 单次模式下重置状态
          // if (this.singal) {
          //   this.index = 0
          //   this.pictureList = []
          // }
        }
      } catch (error) {}
    },
    async uploadImageBlob(blob) {
      try {
        // 2. 构造 FormData（和之前一致）
        const formData = new FormData()
        const fileName = `canvas-image-${Date.now()}.png`
        formData.append('file', blob, fileName) // 字段名 'file' 需与后端一致
        // 3. 验证 FormData（可选，确认数据正常）

        let response = null
        await uploadImg(formData).then((res) => {
          response = res.url
        })

        // 7. 兼容上层逻辑的返回格式（和原代码一致）
        return {
          data: response, // 转为字符串，适配上层 JSON.parse
          errMsg: 'upload:ok',
        }
      } catch (error) {
        // 8. 错误处理（分类展示，更清晰）
        let errorMsg
        if (error.code === 'ECONNABORTED') {
          errorMsg = '上传超时（超过60秒）'
        } else if (error.response) {
          // 接口返回错误（400/500 等）
          errorMsg = `接口错误：状态码 ${
            error.response.status
          }，信息：${JSON.stringify(error.response.data)}`
        } else if (error.request) {
          // 网络错误（无响应）
          errorMsg = '网络错误：无法连接到服务器'
        } else {
          // 其他错误（如参数错误）
          errorMsg = `上传失败：${error.message}`
        }

        throw new Error(errorMsg) // 抛出错误让上层捕获
      }
    },
    preloadFonts(fontList) {
      return Promise.all(
        fontList.map((item) => {
          // 给每个字体加载的 Promise 传递加载状态
          return new Promise((resolve) => {
            if (!item.fontFamily || !item.url) {
              // 无效字体配置：返回状态
              resolve({
                fontFamily: item.fontFamily,
                success: false,
                error: '缺少 fontFamily 或 url',
              })
              return
            }

            try {
              const font = new FontFace(item.fontFamily, `url(${item.url})`, {
                weight: item.fontWeight || 'normal',
                style: item.fontStyle || 'normal',
              })

              font
                .load()
                .then(() => {
                  document.fonts.add(font)
                  // 加载成功：传递 success: true
                  resolve({
                    fontFamily: item.fontFamily,
                    success: true,
                    error: null,
                  })
                })
                .catch((err) => {
                  // 加载失败：传递错误信息
                  resolve({
                    fontFamily: item.fontFamily,
                    success: false,
                    error: err.message || '加载失败',
                  })
                })
            } catch (err) {
              // 异常：传递错误信息
              resolve({
                fontFamily: item.fontFamily,
                success: false,
                error: err.message || '未知异常',
              })
            }
          })
        })
      )
    },
  },
}
</script>

<style scoped lang="less">
// .content {
//   width: 349px;
//   height: 465px;
//   margin: 0 auto;
// }
</style>